<template>
  <div class="subscription-plans">
    <v-row>
      <v-col v-for="plan in filteredPlans" :key="plan.id" cols="12" :md="columnSize">
        <v-card
          class="h-100 rounded-xl"
          :class="{
            'standard-plan': plan.slug === 'standard' || plan.id === 'standard',
            'selected': isSelected(plan.id)
          }"
          variant="outlined"
          :theme="plan.slug === 'standard' || plan.id === 'standard' ? 'dark' : undefined"
          @click="selectPlan(plan)"
          style="cursor: pointer"
        >
          <v-card-item>
            <v-card-title class="text-h5 pb-2">{{ plan.name }}</v-card-title>
            <div class="text-h4 font-weight-bold mb-1" :class="{'text-white': plan.slug === 'standard' || plan.id === 'standard'}">
              CHF {{ Number(plan.price).toFixed(0) }}
              <span class="text-subtitle-1 font-weight-regular" :class="{'text-white': plan.slug === 'standard' || plan.id === 'standard'}">/month</span>
            </div>
            <v-chip 
              v-if="plan.slug === 'standard' || plan.id === 'standard'"
              color="white" 
              class="font-weight-bold mb-2 rounded-xl"
            >
              Most Popular
            </v-chip>
          </v-card-item>
          <v-card-text class="pt-2">
            <v-list
              class="plan-features pa-0"
              :bg-color="plan.slug === 'standard' || plan.id === 'standard' ? 'transparent' : 'white'"
            >
              <!-- Posts per month -->
              <v-list-item
                class="px-0 py-1"
                density="compact"
                :class="{
                  'text-white': plan.slug === 'standard' || plan.id === 'standard'
                }"
              >
                <template v-slot:prepend>
                  <v-icon
                    :color="plan.slug === 'standard' || plan.id === 'standard' ? 'white' : 'primary'"
                    icon="mdi-check-circle"
                    size="small"
                    class="mr-2"
                  ></v-icon>
                </template>
                <v-list-item-title class="text-body-1 posts-per-month">
                  <span class="text-h5 font-weight-bold">{{ plan.posts_per_month }}</span> blog posts per month
                </v-list-item-title>
              </v-list-item>

              <!-- SEO optimization -->
              <v-list-item
                class="px-0 py-1"
                density="compact"
                :class="{
                  'text-white': plan.slug === 'standard' || plan.id === 'standard'
                }"
              >
                <template v-slot:prepend>
                  <v-icon
                    :color="plan.slug === 'standard' || plan.id === 'standard' ? 'white' : 'primary'"
                    icon="mdi-check-circle"
                    size="small"
                    class="mr-2"
                  ></v-icon>
                </template>
                <v-list-item-title class="text-body-1">SEO optimization</v-list-item-title>
              </v-list-item>

              <!-- Multi platform -->
              <v-list-item
                class="px-0 py-1"
                density="compact"
                :class="{
                  'text-white': plan.slug === 'standard' || plan.id === 'standard'
                }"
              >
                <template v-slot:prepend>
                  <v-icon
                    :color="plan.slug === 'standard' || plan.id === 'standard' ? 'white' : 'primary'"
                    icon="mdi-check-circle"
                    size="small"
                    class="mr-2"
                  ></v-icon>
                </template>
                <v-list-item-title class="text-body-1">Multi platform</v-list-item-title>
              </v-list-item>

              <!-- Multi-language support -->
              <v-list-item
                class="px-0 py-1"
                density="compact"
                :class="{
                  'text-white': plan.slug === 'standard' || plan.id === 'standard'
                }"
              >
                <template v-slot:prepend>
                  <v-icon
                    :color="plan.slug === 'standard' || plan.id === 'standard' ? 'white' : 'primary'"
                    icon="mdi-check-circle"
                    size="small"
                    class="mr-2"
                  ></v-icon>
                </template>
                <v-list-item-title class="text-body-1">Multi-language support</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions v-if="showSubscribeButton !== false" class="justify-center pa-4 mt-auto">
            <v-btn
              :color="plan.slug === 'standard' || plan.id === 'standard' ? 'white' : 'primary'"
              block
              class="subscribe-btn rounded-xl text-none"
              :class="{
                'text-primary': plan.slug === 'standard' || plan.id === 'standard',
                'standard-btn': plan.slug === 'standard' || plan.id === 'standard',
                'regular-btn': !(plan.slug === 'standard' || plan.id === 'standard')
              }"
              elevation="1"
              @click.stop="selectPlan(plan)"
              :disabled="isCurrentPlan(plan.id)"
            >
              SUBSCRIBE NOW
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionPlans',
  props: {
    plans: {
      type: Array,
      required: true
    },
    selectedPlanId: {
      type: [Number, String],
      default: null
    },
    currentPlanId: {
      type: [Number, String],
      default: null
    },
    columnSize: {
      type: [Number, String],
      default: 4
    },
    excludeCurrentPlan: {
      type: Boolean,
      default: false
    },
    showSubscribeButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    filteredPlans() {
      console.log('All plans:', this.plans);
      console.log('Current plan ID:', this.currentPlanId);
      if (this.excludeCurrentPlan && this.currentPlanId) {
        const filtered = this.plans.filter(plan => plan.id !== this.currentPlanId);
        console.log('Filtered plans:', filtered);
        return filtered;
      }
      return this.plans;
    }
  },
  methods: {
    isSelected(planId) {
      return this.selectedPlanId === planId;
    },
    isCurrentPlan(planId) {
      return this.currentPlanId === planId;
    },
    selectPlan(plan) {
      this.$emit('select-plan', plan);
    }
  }
}
</script>

<style scoped>
.subscription-plans {
  --primary-color: #2E7D32;
}

.v-card {
  border: 1px solid #e0e0e0 !important;
  transition: all 0.3s ease;
  background: white !important;
}

.v-card.selected {
  border: 2px solid var(--primary-color) !important;
  box-shadow: 0 4px 8px rgba(46, 125, 50, 0.15) !important;
}

.standard-plan {
  background: linear-gradient(135deg, #2E7D32 0%, #81C784 100%) !important;
  border: none !important;
}

.standard-plan.selected {
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.3) !important;
  border: 2px solid white !important;
}

.standard-plan :deep(.v-card-title),
.standard-plan :deep(.text-h3),
.standard-plan :deep(.text-body-1),
.standard-plan :deep(.v-list-item-title) {
  color: white !important;
}

.v-list.plan-features {
  --v-theme-overlay-multiplier: 0;
  background: transparent !important;
}

.plan-features .v-list-item {
  min-height: 32px !important;
  margin-bottom: 8px !important;
}

.plan-features .v-list-item-title {
  font-size: 1rem !important;
  font-weight: 400 !important;
  letter-spacing: 0 !important;
  line-height: 1.5 !important;
}

.posts-per-month {
  font-size: 1.1rem !important;
  line-height: 1.75 !important;
}

.posts-per-month .text-h5 {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  display: inline-block;
  margin-right: 4px;
}

.subscribe-btn {
  text-transform: uppercase !important;
  letter-spacing: 0.0892857143em !important;
  font-weight: 500 !important;
  margin-top: 24px !important;
  height: 48px !important;
  font-size: 0.875rem !important;
}

.standard-btn {
  background-color: white !important;
  color: var(--primary-color) !important;
}

.regular-btn {
  background-color: var(--primary-color) !important;
  color: white !important;
}

@media (min-width: 960px) {
  .v-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
  }
}
</style> 